import "./Table.scss";
import { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Radio,
  Table as TableAntd,
  Descriptions,
  Button,
  notification,
  Icon,
  Tooltip
} from "antd";

import { useTranslation } from "react-i18next";
import { FieldSet, Paragraph } from '..'
import FormConfigBadges from '../FormConfigBadges/FormConfigBadges'
import { globalContext } from "../../../../../contexts";
import apiConfig from "../../../../../config/api";

const Table = ({ formId, client, record, section, component, mode, lang, handleChangeValues, showErrors }) => {
  const { t } = useTranslation('forms')
	const { datasources } = useContext(globalContext)
  const [columns, setColumns] = useState([])
  const [fieldsPdf, setFieldsPdf] = useState({})
  const [ error, setError ] = useState(null)
  const [ validateForm, setValidateForm ] = useState(false)
  const [ cleanFieldsV, setCleanFieldsV ] = useState(null)
  const [ comp, setComp ] = useState({...JSON.parse(JSON.stringify(component)), records: component.records??[]})
  const declarationRisks = Array.isArray(component.risks) ? component.risks : []
  const risksForYes = declarationRisks.filter(item => item && item.decision === true)
  const risksForNo = declarationRisks.filter(item => item && item.decision === false)
  const showRiskBadges = component.type === 'DECL' && mode === 'preview' &&
    (risksForYes.length > 0 || risksForNo.length > 0)

  useEffect(() => {
    const initCols = async () => {
      let cols = []
      let fields = {}
      if(component.fieldSet && component.fieldSet.fields) {
        component.fieldSet.fields.map(field => {
          // Excluir campos de tipo SUBTITLE de las columnas y del PDF
          if(field.typeField !== 'SUBTITLE') {
            fields[field.key] = field
            if(field.tableVisible === true || mode === "pdf") {
              cols.push({
                title: field.title && field.title[lang],
                dataIndex: field.key,
                render: (text, record, index) => {
                  return getValueField(record, field)
                }
              })
            }
          }
        })
      }
      if(mode !== 'pdf' && handleChangeValues) {
        cols.push({
          title: t('forms.label.accion'),
          width: '80px',
          className: "btn-actions",
          render: (text, record, index) => {
            return (
              <Tooltip title={t('forms.tooltip.delete')}>
                <Button icon="delete" size="small" onClick={() => removeRecord(index)} />
              </Tooltip>
            )
          }
        })
        //verifyValidations()
      }else {
        setFieldsPdf(fields)
      }
      setColumns(cols)
      cleanFields()
    }
    if(datasources) initCols()
  }, [mode, datasources])

  const getValueField = (record, field) => {
    let value = record[field.key]
    if(field.typeField === "CHECKBOX") {
      if(value) value = <Icon type="check"/>
    }else if(field.typeField === "FILE") {
      return <a target="_blank" download={value.name} href={apiConfig.url + "/form/getFile/" + formId + "?name=" + encodeURI(value.name) + "&path=" + encodeURI(value.path)}>{value.name}</a>
    }else if(field.source) {
      if(field.typeField === "SELECT" || field.typeField === "RADIO" || field.typeField === "RADIOOTHER") {
        if(field.typeField === "RADIOOTHER" && value?.startsWith('OTHER-')) {
          value = value.substring(6)
        }else {
          value = getValuesFromDS(field, value)
        }
      }
    }
    return value
  }

  const getValuesFromDS = (field, value) => {
    if(datasources && field.source && field.source.indexOf(':') > 0) {
      let ds = field.source.split(':')
      if(datasources[ds[0]] && datasources[ds[0]][ds[1]]) {
        let datasource = datasources[ds[0]][ds[1]]
        if(datasource.values) {
          const val = datasource.values.filter(v => v.code === value)
          if(val.length > 0) return val[0].jsonValue[lang]
        }
      }
    }
    return value
  }

  const verifyValidations = () => {
    if(component.type === 'DECL') {
      if((component.decision === null || component.decision === undefined) && mode !== 'pdf') {
        setError(t('forms.errors.mustSelectDecision'))
      }else if(component.decision) {
        const minRows = parseInt(component.fieldSet?.minRows ?? 1, 10)
        if(component?.records?.length < minRows) {
          setError(t('forms.errors.mustAddRecords', {minRows}))
        }else {
          setError(null)
        }
      } 
    }else if(component.type === 'TABLE') {
      const minRows = parseInt(component?.fieldSet?.minRows ?? 0, 10)
      if(component?.records?.length < minRows) {
        setError(t('forms.errors.mustAddRecords', {minRows}))
      }else {
        setError(null)
      }
    }
  }

  const toDescriptionsPdf = (records) => {
    return <>
      {records.map((record, index) => (
        <>
          <div className="descriptions-pdf">
            <h4 className="descriptions-numeral">#{index + 1}</h4>
            <Descriptions title="" column={1} bordered size="small">
              {Object.entries(fieldsPdf).map(([key,field]) => {
                return (
                  <Descriptions.Item label={fieldsPdf[key].title && fieldsPdf[key].title[lang]}>
                    { getValueField(record, field) }
                  </Descriptions.Item>
                );
              })}
            </Descriptions>
          </div>
          <br />
        </>
      ))}
    </>
  };

  const handleChangeDecision = (value) => {
    refreshSectionKey('decision', value)

    const minRows = parseInt(component.fieldSet?.minRows ?? 1, 10)
    if(value && component.records && component.records.length < minRows) {
      setError(t('forms.errors.mustAddRecords', {minRows}))
    }else {
      setError(null)
    }
  }

  const refreshSectionKey = (key, value, updateValues=true) => {
    let c = {...comp, [key]: value}
    setComp(c)
    handleChangeValues && handleChangeValues(c, updateValues)
  }

  const handleChangeValuesFn = (fieldSet) => {
    if(handleChangeValues) {
      refreshSectionKey('fieldSet', fieldSet, false)
      setValidateForm(false)
    }
  }

  const removeRecord = (index) => {
    let t = { ...comp }
    let records = t.records
    records.splice(index, 1)
    refreshSectionKey('records', records)
    verifyValidations()
  }

  const addRecord = () => {
    setValidateForm(true)
    let emptys = comp.fieldSet.fields.filter(f => f.visible && f.required && f.typeField !== 'SUBTITLE' && (f.value===null || f.value===undefined || f.value===''))
    if(emptys.length > 0) {
      notification.error({
        message: t('forms.errors.requiredFields')
      })
    }else {
      let errors = comp.fieldSet.fields.filter(f => f.visible && f.errors && f.errors.length > 0)
      if(errors.length > 0) {
        notification.error({
          message: t('forms.errors.invalidData')
        })
      }else {
        let t = { ...comp }
        let records = t.records ? t.records : []
        let fields = {}
        // Excluir campos SUBTITLE al agregar registros a la tabla
        comp.fieldSet.fields.filter(f => f.typeField !== 'SUBTITLE').map((f,index) => {
          fields[f.key] = f.value
        })
        records.push(fields)

        cleanFields()
        refreshSectionKey('records', records)
        verifyValidations();
      }
    }
  }

  const getRandomId = () => {
    return 'R' + Math.floor(Math.random() * 1000000);
  }

  const cleanFields = () => {
    let fieldSet = { ...comp.fieldSet }
    fieldSet.fields && fieldSet.fields.map(field => {
      field.value = null
      field.text = null
    })
    setCleanFieldsV(getRandomId())

    handleChangeValuesFn(fieldSet)
  }

  return (
    <div className="form-manager-table-form">
      { component.type === 'TABLE' &&
      <Row className="header-table">
        { mode !== 'pdf' && error !== null && showErrors && <Row className="has-errors-fieldset">{error}</Row>}
        <Col span={24} style={{textAlign: 'justify'}}>
            <Paragraph component={component} record={record} mode={mode} lang={lang} handleChangeValues={mode !== 'pdf' ? handleChangeValues:null} />
        </Col>
      </Row>
      }
      { component.type === 'DECL' &&
      <Row className="header-table">
        { mode !== 'pdf' && error !== null && showErrors && <Row className="has-errors-fieldset">{error}</Row>}
        <Col span={showRiskBadges ? 21 : 22} style={{textAlign: 'justify', paddingRight: (mode==='pdf' ? 10 : 0)}}>
            <Paragraph component={component} record={record} mode={mode} lang={lang} handleChangeValues={mode !== 'pdf' ? handleChangeValues:null} />
        </Col>
        <Col span={showRiskBadges ? 3 : 2}>
            { mode === "pdf" ?
              <div>
                <div>
                  <input type="radio" checked={comp.decision === true} /> {t('forms.manager.tableEdit.yes')}
                </div>
                <div>
                  <input type="radio" checked={comp.decision === false} /> {t('forms.manager.tableEdit.no')}
                </div>
              </div>
            :
              <Radio.Group className="decision-risk-radio-group" value={comp.decision} onChange={(e) => mode !== 'pdf' && handleChangeDecision(e.target.value)}>
                <div className="decision-risk-option">
                  <span className="decision-risk-badge">
                  <FormConfigBadges
                    mode={mode}
                    risks={risksForYes}
                    riskConditionKey="decision"
                  />
                  </span>
                  <Radio className="radio-switch" value={true}>{t('forms.manager.tableEdit.yes')}</Radio>
                </div>
                <div className="decision-risk-option">
                  <span className="decision-risk-badge">
                  <FormConfigBadges
                    mode={mode}
                    risks={risksForNo}
                    riskConditionKey="decision"
                  />
                  </span>
                  <Radio className="radio-switch" value={false}>{t('forms.manager.tableEdit.no')}</Radio>
                </div>
              </Radio.Group>
            }
        </Col>
      </Row>
      }
      { component.fieldSet && (component.type === 'TABLE' || comp.decision === true) &&
      <>
        { mode !== 'pdf' &&
          <>
            <FieldSet
              formId={formId}
              client={client}
              record={record}
              section={section} 
              parent={component}
              component={component.fieldSet} 
              mode={mode} 
              lang={lang}
              showErrors={validateForm}
              handleChangeValues={handleChangeValuesFn} 
              //validateForm={validateForm}
              cleanFields={cleanFieldsV}
            />
            <Row className="btns-table">
              <Button onClick={mode !== "pdf" && addRecord}>{t('forms.añadir')}</Button>
              <Button onClick={mode !== "pdf" && cleanFields}>{t('forms.limpiar')}</Button>
            </Row>
          </>
        }
        { comp.records &&
        <>
          { (mode !== 'pdf' || columns.length < 5) ? 
            <>
            { comp.records.length > 0 &&
            <TableAntd 
              columns={columns} 
              size="small" 
              dataSource={comp.records} 
              pagination={comp.records && comp.records.size > 10 ? true : false} 
              className={"table-rows mode-" + mode}
            />
            }
            </>
            :
            toDescriptionsPdf(comp.records)
          }
        </>
        }
      </>
      }
    </div>
  )
}

export default Table;
